import React, { useState, useEffect, useCallback, useImperativeHandle, useRef } from "react";
import api from "api/api";
import PropTypes from "prop-types";

import Select from "react-select";

import { useSelector } from "react-redux";

import ActionStandardConsumerFilter from "./ActionStandardConsumerFilter";
import MultiSelectWithCheckbox from "./MultiSelectWithCheckbox";

const weightOptions = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
];

const confidenceIntervalOptions = [
    { value: "90", label: "90%" },
    { value: "95", label: "95%" },
    { value: "99", label: "99%" },
];

const FragranceActionStandardForm = React.forwardRef(function FragranceActionStandardForm({ getAsFormData = () => { }, tabId, sampleInformation = 0, coreDataId, studyTypeMethod, formData = {}, getAsCfData = () => { }, isWeighted, validation = {}, coreData }, ref) {
    const inputRef1 = useRef(null);
    const inputRef2 = useRef(null);
    const displayLabelTransition = useSelector((state) => state.dataMappingStore.displayLabelTranslation);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;
    const isICT = coreData?.study_type_method__title.toLowerCase() === "ict";

    const [cfSelectionData, setCfSelectionData] = useState({});
    // const [cfSelectionDataLabel, setCfSelectionDataLabel] = useState([]);
    const [consumerFilter, setConsumerFilter] = useState({});
    const [ulPro, setUlPro] = useState(null);
    const [CmPro, setCmPro] = useState([]);

    useImperativeHandle(ref, () => ({
        reset() {
            if (inputRef1.current) {
                inputRef1.current.value = ""; // Clears the input's value
            }
            if (inputRef2.current) {
                inputRef2.current.value = ""; // Clears the input's value
            }
        },
    }));

    const fetchConsumerFilterData = useCallback(
        async (ulPc, cmp) => {
            if (ulPc && cmp?.length > 0 && coreDataId) {
                try {
                    const products = `${ulPc},${cmp.map((c) => c.value).join(",")}`;
                    let url =
                        process.env.REACT_APP_SERVER_PATH +
                        `/data-mappings/dynamic-consumer-filters/?uniq=true&core_data_model=${coreDataId}&variable_category=${encodeURIComponent("Consumer Filter,Study Filter,Consumer Filter related to Product Trial")}&combined=true&products=${encodeURIComponent(products)}`;
                    if (productCategoryId) {
                        url += `&product_category=${productCategoryId}`;
                    }
                    if (studyTypeMethod) {
                        url += `&study_type_method=${studyTypeMethod}`;
                    }
                    await api
                        .get(url)
                        .then((res) => {
                            setConsumerFilter(res?.data || {});
                        })
                        .catch((error) => {
                            console.error("Error 1:", error.message);
                        });
                } catch (error) {
                    console.error("Error 2:", error.message);
                }
            } else {
                console.error("disable cf");
            }
        },
        [coreDataId]
    );

    useEffect(() => {
        fetchConsumerFilterData(ulPro, CmPro);
    }, [ulPro, CmPro, fetchConsumerFilterData]);

    const getCfData = (data) => {
        setCfSelectionData(data);
        // setCfSelectionDataLabel(label);
        getAsFormData(tabId, data, "consumer_filter");
        getAsCfData(tabId, data, ulPro, CmPro); // call grouped api
    };

    useEffect(() => {
        setCfSelectionData(formData?.consumer_filter || {});
        setUlPro(formData?.ul_product_code);
        const compProducts = formData?.comp_product_code?.split(",") || [];
        const filteredCompArr = formData?.competitorProducts?.filter(ele => compProducts?.includes(ele.value));
        setCmPro(filteredCompArr);
    }, [formData]);

    const handleFilterLabelData = (filterLabels) => {
        let textFilters = "";
        Object.keys(filterLabels).forEach((ele) => {
            const label = displayLabelTransition?.[ele] || ele;
            textFilters += label + " : [" + filterLabels[ele]?.join(",") + "]<br />";
        });

        return textFilters;
    };

    return (
        <div
            style={{
                border: "1px solid rgb(232, 232, 232)",
                background: "#fff",
            }}
        >
            <div
                style={{
                    display: "flex",
                }}
            >
                <div
                    className="as-input-container"
                    style={{
                        width: "39%",
                    }}
                >
                    <label className="as-input-label">Sample Information:</label>
                    <input
                        type="text"
                        name="sampleInformation"
                        className="text-input-dialog as-input-field"
                        placeholder="Sample Information"
                        disabled={true}
                        value={sampleInformation}
                    />
                </div>
                <div
                    style={{
                        width: "20%",
                    }}
                >
                    <div className="as-input-container">
                        <label className="as-input-label">Weight:</label>
                        <Select
                            className="dialogue-dropdown as-input-field"
                            name={"weight"}
                            placeholder={"Weight"}
                            value={{
                                label: formData?.weight ? "Yes" : "No",
                                value: formData?.weight,
                            }}
                            options={weightOptions}
                            onChange={(e) => getAsFormData(tabId, e.value, "weight")}
                            // isDisabled={Object.keys(cfSelectionData).length !== 0 ? true : false}
                            isDisabled={isWeighted ? (Object.keys(cfSelectionData).length !== 0 ? true : false) : true}
                        />
                    </div>
                    {/* <div
                            style={{
                                color: "#FF0000",
                                margin: "2px 10px"
                            }}
                        >
                            {error && Object.keys(error).length > 0 ? Object.keys(error).includes("weight") ? error.weight : "" : ""}
                        </div> */}
                </div>
                <div
                    style={{
                        width: "39%",
                    }}
                >
                    <div className="as-input-container">
                        <label className="as-input-label">Confidence Interval:</label>
                        <Select
                            className="dialogue-dropdown as-input-field"
                            name={"confidence_interval"}
                            placeholder={"Confidence Interval"}
                            options={!isICT ? confidenceIntervalOptions : confidenceIntervalOptions.filter(opt => ["95", "99"].includes(opt.value))}
                            value={{
                                label: formData?.confidence_interval,
                                value: formData?.confidence_interval,
                            }}
                            onChange={(e) => getAsFormData(tabId, e.value, "confidence_interval")}
                        />
                    </div>
                    <span
                        style={{
                            color: "#FF0000",
                            margin: "2px 10px",
                        }}
                    >
                        {validation && validation.confidence_interval ? validation.confidence_interval : ""}
                    </span>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                }}
            >
                <div
                    style={{
                        width: "50%",
                    }}
                >
                    <div className="as-input-container">
                        <label className="as-input-label">Unilever Product:</label>
                        <Select
                            className="dialogue-dropdown as-input-field"
                            name={"ul_product_code"}
                            placeholder={"Unilever Products"}
                            value={{
                                label: formData?.ul_product_code,
                                value: formData?.ul_product_code,
                            }}
                            options={formData?.unileverProducts || []}
                            onChange={(e) => {
                                getAsFormData(tabId, e.value, "ul_product_code");
                                setUlPro(e.value);
                            }}
                        />
                    </div>
                    <span
                        style={{
                            color: "#FF0000",
                            margin: "2px 10px",
                        }}
                    >
                        {validation && validation.ul_product_code ? validation.ul_product_code : ""}
                    </span>
                </div>

                <div
                    className="as-input-container"
                    style={{
                        width: "50%",
                    }}
                >
                    <label className="as-input-label">Sample Size:</label>
                    <input
                        ref={inputRef1}
                        type="text"
                        name="ul_product_sample_size"
                        className="text-input-dialog as-input-field"
                        placeholder="Sample Size"
                        disabled={true}
                        value={formData?.ul_product_sample_size}
                    />
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                }}
            >
                <div
                    style={{
                        width: "50%",
                    }}
                >
                    <div className="as-input-container">
                        <label className="as-input-label">Benchmark Product:</label>
                        <MultiSelectWithCheckbox
                            options={formData?.competitorProducts || []}
                            value={CmPro}
                            onChange={(selectedOptions) => {
                                getAsFormData(tabId, selectedOptions, "comp_product_code");
                                setCmPro(selectedOptions);
                            }}
                        />
                    </div>
                    <span
                        style={{
                            color: "#FF0000",
                            margin: "2px 10px",
                        }}
                    >
                        {validation && validation.comp_product_code ? validation.comp_product_code : ""}
                    </span>
                </div>
                <div
                    className="as-input-container"
                    style={{
                        width: "50%",
                    }}
                >
                    <label className="as-input-label">Sample Size:</label>
                    <input
                        ref={inputRef2}
                        type="text"
                        name="comp_product_sample_size"
                        className="text-input-dialog as-input-field"
                        placeholder="Sample Size"
                        disabled={true}
                        value={formData?.comp_product_sample_size}
                    />
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                }}
            >
                <div
                    className="as-input-container"
                    style={{
                        width: "51%",
                    }}
                >
                    <label className="as-input-label">Consumer Filter:</label>
                    <ActionStandardConsumerFilter
                        appliedFilters={cfSelectionData}
                        handleFilterSubmitData={getCfData}
                        // handleFilterLabelData={handleFilterLabelData}
                        disableFilter={!(ulPro && CmPro?.length > 0)}
                        consumerFilter={consumerFilter}
                        coreData={coreData}
                    />
                </div>
                <div
                    className="as-input-container"
                    style={{
                        width: "50%",
                    }}
                >
                    {/* <textarea 
                            name="consumerFilterSelected" 
                            rows="3" 
                            cols="112"
                            disabled="true"
                            className="as-textarea"
                        >
                           {filtersText} 
                        </textarea> */}
                    <div
                        className="as-textarea"
                        dangerouslySetInnerHTML={{ __html: handleFilterLabelData(cfSelectionData) }}
                    ></div>
                </div>
            </div>
        </div>
    );
});

FragranceActionStandardForm.propTypes = {
    tabId: PropTypes.number,
    sampleInformation: PropTypes.number,
    getAsFormData: PropTypes.func,
    getAsCfData: PropTypes.func,
    formData: PropTypes.object,
    coreDataId: PropTypes.number,
    studyTypeMethod: PropTypes.number,
    validation: PropTypes.object,
    coreData: PropTypes.object,
    consumerFilter: PropTypes.object,
    isWeighted: PropTypes.bool,
};

export default FragranceActionStandardForm;
